import { applyMiddleware, combineReducers, compose, legacy_createStore as _createStore, Reducer } from 'redux';
import { withExtraArgument } from 'redux-thunk';
import * as allReducers from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore, TReduxActions, TThunkDispatch } from '../../types/redux';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers(allReducers) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnhancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<IApplicationState, TReduxActions, IThunkExt, {}>(reducers, initialState, storeEnhancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
